import React, { useState } from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import FrameworkSelection from './pages/FrameworkSelection';
import RoleSelection from './pages/RoleSelection';
import QuestionsPage from './pages/QuestionsPage';
import ResultsPage from './pages/ResultsPage';
import { UserSession, Answer } from './types';

type Page = 'landing' | 'framework' | 'role' | 'questions' | 'results';

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('landing');
  const [session, setSession] = useState<UserSession>({
    framework: '',
    role: '',
    answers: []
  });

  const handleFrameworkSelect = (framework: string) => {
    setSession({ ...session, framework });
    setCurrentPage('role');
  };

  const handleRoleSelect = (role: string) => {
    setSession({ ...session, role });
    setCurrentPage('questions');
  };

  const handleAnswersSubmit = (answers: Answer[]) => {
    setSession({ ...session, answers });
    setCurrentPage('results');
  };

  const handleRestart = () => {
    setSession({ framework: '', role: '', answers: [] });
    setCurrentPage('landing');
  };

  return (
    <div className="App">
      {currentPage === 'landing' && (
        <LandingPage onStart={() => setCurrentPage('framework')} />
      )}
      {currentPage === 'framework' && (
        <FrameworkSelection onSelect={handleFrameworkSelect} />
      )}
      {currentPage === 'role' && (
        <RoleSelection onSelect={handleRoleSelect} />
      )}
      {currentPage === 'questions' && (
        <QuestionsPage
          framework={session.framework}
          role={session.role}
          onComplete={handleAnswersSubmit}
        />
      )}
      {currentPage === 'results' && (
        <ResultsPage
          session={session}
          onRestart={handleRestart}
        />
      )}
    </div>
  );
}

export default App;
